declare global {
  interface Array<T> {
    sum(selector: (item: T) => number, startFrom: number): number;
    max(selector: (item: T) => number, startFrom: number): number;
  }
}

Array.prototype.sum = function <T>(
  selector: (item: T) => number,
  startFrom: number = 0
): number {
  return this.reduce((acc: number, cur: T) => acc + selector(cur), startFrom);
};

Array.prototype.max = function <T>(
  selector: (item: T) => number,
  startFrom: number = 0
): number {
  return this.reduce(
    (acc: number, cur) => Math.max(acc, selector(cur)),
    startFrom
  );
};

export {};
